<template>
<section v-if="variants.v1 === variant" class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
  <div class="container tw-mt-10 lg:tw-mt-5">
    <BlockSymbol
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :image-class="`tw-max-w-full lg:tw-max-w-[50%]`"
      :block-logo-image="String(vars?.blockLogoImage)"
      :company-key="company?.company_key"

    />
    <div class="">
      <div class="row justify-between items-center">
        <h1 class="col-auto">{{ vars.titleText }}</h1>

        <div v-if="vars.descriptionText" class="col-xl-6 md:d-none">
          <p class="!tw-text-white">{{ vars.descriptionText }}</p>
        </div>
      </div>
    </div>

    <div class="tw-hidden lg:tw-grid tw-grid-cols-12 tw-gap-5">
      <div class="lg:tw-col-span-8 tw-flex tw-flex-col tw-justify-between tw-pb-2">
        <Theme7BlogsBlogCard key="blog-main" :blog="mainBlog" :index="0" :component="component" :variables="vars" version="static-v1"/>
        <div class="tw-flex tw-flex-col tw-gap-5">
          <h2>{{ vars.secondTitleText }}</h2>
          <nuxt-link :to="`${vars.mainButtonLinkUrl}`" :external="true" class="tw-max-w-fit" :class="`n-${vars.mainButtonTypeText}`">
            {{ vars.mainButtonLabelText }}
          </nuxt-link>
        </div>
      </div>
      <div class="lg:tw-col-span-4">
        <Theme7BlogsBlogCard v-for="(blog, index) in remainingBlogs" :key="blog.id" :blog="blog" :index="index + 1" :component="component" :variables="vars" version="static-v1"/>
      </div>
    </div>

    <div class="tw-block lg:tw-hidden">
      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider tw-z-10 lg:!tw-hidden"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-3 lg-2 md-1 sm-1 base-1"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(blog, index) in blogs" :key="`latestblogs-blog-${index}`">
            <Theme7BlogsBlogCard
              version="static-v1"
              :button-type-text="vars.buttonTypeText"
              :text-color="vars.textColor"
              :blog="blog"
              :index="index"
              :component="component"
              :variables="vars"
            />
          </div>
        </div>

        <div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-start">
          <button
            class="sliderNav -prev js-prev n-link !tw-bg-transparent !tw-text-white"
            style="border-color: white !important"
          >
            <i class="icon-left-arrow"></i>
          </button>
          <button
            style="border-color: white !important"
            class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent !tw-text-white"
          >
            <i class="icon-right-arrow"></i>
          </button>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-5 tw-mt-10">
          <h2>{{ vars.secondTitleText }}</h2>
          <nuxt-link :to="`${vars.mainButtonLinkUrl}`" :external="true" class="tw-max-w-fit" :class="`n-${vars.mainButtonTypeText}`">
            {{ vars.mainButtonLabelText }}
          </nuxt-link>
        </div>
      </div>
    </div>

  </div>
</section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import type { Component } from '~/types';
import { useWebsiteStore } from '~/units/website/store';
import BlogCard from './BlogCard.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'Theme7SelectedBlogsBox',

  components: {
    BlogCard,
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  computed: {
    ...mapState(useWebsiteStore, ['theme', 'sidebarComponents','company']),

    blogs(): any[] {
      return this.groupedVariables.blogs || [];
    },

    mainBlog(): any {
      return this.blogs.length ? this.blogs[0] : null;
    },

    remainingBlogs(): any[] {
      return this.blogs.length > 1 ? this.blogs.slice(1, 3) : [];
    },
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
      },
    };
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>
